var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "service-page" } },
    [
      _c("div", { staticClass: "close-block" }, [
        _c(
          "a",
          {
            staticClass: "close-block-button",
            on: {
              click: function ($event) {
                return _vm.leaveService()
              },
            },
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor",
                  "aria-hidden": "true",
                },
              },
              [
                _c("path", {
                  attrs: {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M6 18L18 6M6 6l12 12",
                  },
                }),
              ]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("loader", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.serviceLoadStatus == 0 || _vm.serviceLoadStatus == 1,
            expression: "serviceLoadStatus == 0 || serviceLoadStatus == 1",
          },
        ],
        attrs: { width: 100, height: 100 },
      }),
      _vm._v(" "),
      _vm.serviceLoadStatus == 2
        ? _c("h2", { staticClass: "service-title" }, [
            _vm._v(_vm._s(_vm.service.name) + "\n        "),
            _vm.workroom == 60
              ? _c("span", { staticClass: "service-block-copy" }, [
                  _c("span", { staticClass: "tooltip-service-name" }, [
                    _vm._v(_vm._s(_vm.$t("detail.tooltipCopied"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "copy-btn",
                      on: {
                        click: function ($event) {
                          _vm.copyToClipBoard(
                            _vm.service.name +
                              ", " +
                              _vm.service.street +
                              ", " +
                              _vm.service.city +
                              " (tel. " +
                              _vm.formatPhone(_vm.service.phone[0]) +
                              ")"
                          )
                        },
                      },
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: "/img/icons/copy-icon.svg",
                          title: _vm.$t("detail.buttonCopyAddress"),
                        },
                      }),
                    ]
                  ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.serviceLoadStatus == 2 && _vm.workroom != 60 && _vm.workroom != 860
        ? _c("div", { staticClass: "grid-x" }, [
            _c(
              "div",
              { staticClass: "large-12 medium-12 small-12 cell" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "order-service-button",
                    attrs: {
                      to: {
                        name: "orderservice",
                        params: { slug: _vm.service.slug },
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("detail.orderToServiceButton")) +
                        "\n            "
                    ),
                  ]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.serviceLoadStatus == 2 && _vm.workroom == 860
        ? _c("div", { staticClass: "grid-x" }, [
            _c(
              "div",
              { staticClass: "large-12 medium-12 small-12 cell" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "order-service-button",
                    attrs: {
                      to: {
                        name: "orderinspector",
                        params: { slug: _vm.service.slug },
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("detail.orderReturnWithInspector")) +
                        "\n            "
                    ),
                  ]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.serviceLoadStatus == 2 && _vm.workroom == 60
        ? _c("div", { staticClass: "grid-x" }, [
            _c("div", { staticClass: "large-12 medium-12 small-12 cell" }, [
              _c(
                "a",
                {
                  staticClass: "order-service-button",
                  attrs: {
                    href: _vm.navigationMapLink(
                      _vm.service.latitude,
                      _vm.service.longitude
                    ),
                    target: "_blank",
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("detail.navigateToServiceButton")) +
                      "\n            "
                  ),
                ]
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.serviceLoadStatus == 2
        ? _c("div", { staticClass: "grid-x" }, [
            _c("div", { staticClass: "large-12 medium-12 small-12 cell" }, [
              _vm.workroom == 860
                ? _c("label", { staticClass: "info-label" }, [
                    _vm._v(_vm._s(_vm.$t("detail.infoAboutParkingArea"))),
                  ])
                : _c("label", { staticClass: "info-label" }, [
                    _vm._v(_vm._s(_vm.$t("detail.infoAboutService"))),
                  ]),
              _vm._v(" "),
              _c("div", { staticClass: "info-container" }, [
                _c("span", [_vm._v(_vm._s(_vm.service.street))]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.service.city))]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.service.distance) + " km")]),
              ]),
              _vm._v(" "),
              _vm.service.working_hours ||
              _vm.service.working_hours_sat ||
              _vm.service.working_hours_sun
                ? _c("label", { staticClass: "info-label" }, [
                    _vm._v(_vm._s(_vm.$t("detail.openingHours"))),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.service.working_hours ||
              _vm.service.working_hours_sat ||
              _vm.service.working_hours_sun
                ? _c("div", { staticClass: "info-container" }, [
                    _c(
                      "table",
                      {
                        staticClass: "info-container-table",
                        attrs: {
                          cellpadding: "0",
                          cellspacing: "0",
                          border: "0",
                        },
                      },
                      [
                        _c("tbody", [
                          _vm.service.working_hours
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.$t("detail.openingHoursWeek"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(_vm.service.working_hours)),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.service.working_hours_sat
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("detail.openingHoursSaturday")
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(_vm.service.working_hours_sat)),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.service.working_hours_sun
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.$t("detail.openingHoursSunday"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(_vm.service.working_hours_sun)),
                                ]),
                              ])
                            : _vm._e(),
                        ]),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.service.working_hours ||
              _vm.service.working_hours_sat ||
              _vm.service.working_hours_sun
                ? _c("span", { staticClass: "service-info-text" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("detail.openingHoursNote")) +
                        "\n            "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.workroom == 60
                ? _c("label", { staticClass: "info-label" }, [
                    _vm._v(_vm._s(_vm.$t("detail.contact"))),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.workroom == 60
                ? _c("div", { staticClass: "info-container" }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("detail.contactEmail")) + ": "),
                      _c(
                        "a",
                        {
                          staticClass: "service-link",
                          attrs: {
                            target: "_blank",
                            href: "mailto:" + _vm.service.email,
                          },
                        },
                        [_vm._v(_vm._s(_vm.service.email))]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      [
                        _vm._v(
                          _vm._s(_vm.$t("detail.contactPhone")) +
                            ":\n                    "
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.service.phone, function (phone) {
                          return _c(
                            "a",
                            {
                              staticClass: "phone-number",
                              attrs: { href: "tel:" + phone.trim() },
                            },
                            [_vm._v(_vm._s(_vm.formatPhone(phone)))]
                          )
                        }),
                      ],
                      2
                    ),
                  ])
                : _vm._e(),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.serviceLoadStatus == 2 &&
      (_vm.service.pickup_included ||
        _vm.serviceSlotDefinition.pickup_included ||
        _vm.service.replacement_car_included ||
        _vm.service.replacement_car_included == false ||
        _vm.serviceSlotDefinition.replacement_car_included ||
        _vm.service.car_wash_included ||
        _vm.serviceSlotDefinition.car_wash_included) &&
      _vm.workroom != 860
        ? _c("div", { staticClass: "grid-x" }, [
            _c(
              "div",
              { staticClass: "large-12 medium-12 small-12 cell" },
              [
                _c("label", { staticClass: "info-label" }, [
                  _vm._v(_vm._s(_vm.$t("detail.additionalServices"))),
                ]),
                _vm._v(" "),
                _vm.slotDefinition == true
                  ? _c("loader", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.serviceSlotDefinitionLoadStatus == 0 ||
                            _vm.serviceSlotDefinitionLoadStatus == 1,
                          expression:
                            "serviceSlotDefinitionLoadStatus == 0 || serviceSlotDefinitionLoadStatus == 1",
                        },
                      ],
                      attrs: { width: 100, height: 100 },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "extended-services-block" }, [
                  _vm.service.pickup_included == true &&
                  _vm.slotDefinition == false
                    ? _c("div", { staticClass: "extended-services" }, [
                        _c("img", {
                          staticClass: "extended-services-icon",
                          attrs: { src: "/img/icons/pick-up.svg" },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "extended-services-name" }, [
                          _vm._v(
                            _vm._s(_vm.$t("detail.additionalServicesPickUp"))
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.serviceSlotDefinition.pickup_included == true &&
                  _vm.slotDefinition == true
                    ? _c("div", { staticClass: "extended-services" }, [
                        _c("img", {
                          staticClass: "extended-services-icon",
                          attrs: { src: "/img/icons/pick-up.svg" },
                        }),
                        _vm._v(" "),
                        _vm.serviceSlotDefinition.pickup_cond == 1
                          ? _c(
                              "span",
                              { staticClass: "extended-services-name" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("detail.additionalServicesPickUp")
                                  )
                                ),
                                _c("br"),
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("detail.additionalServicesFree")
                                  ) + "*"
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.serviceSlotDefinition.pickup_cond == 0
                          ? _c(
                              "span",
                              { staticClass: "extended-services-name" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("detail.additionalServicesPickUp")
                                  )
                                ),
                              ]
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.service.replacement_car_included == true &&
                  _vm.slotDefinition == false
                    ? _c("div", { staticClass: "extended-services" }, [
                        _c("img", {
                          staticClass: "extended-services-icon",
                          attrs: { src: "/img/icons/replacement-car.svg" },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "extended-services-name" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "detail.additionalServicesReplacementVehicle"
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.extendedServicesDeniedReplacementVehicleCodes.includes(
                          this.replCarEntitlementCode
                        )
                          ? _c(
                              "span",
                              { staticClass: "extended-services-name-sub" },
                              [
                                _vm._v(
                                  "(" +
                                    _vm._s(
                                      _vm.$t(
                                        "detail.additionalServicesNotAgreed"
                                      )
                                    ) +
                                    ")"
                                ),
                              ]
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.service.replacement_car_included == false &&
                  _vm.slotDefinition == false
                    ? _c("div", { staticClass: "extended-services" }, [
                        _c("img", {
                          staticClass: "extended-services-icon",
                          attrs: { src: "/img/icons/replacement-car.svg" },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "extended-services-name" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "detail.additionalServicesReplacementVehicle"
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.extendedServicesDeniedReplacementVehicleCodes.includes(
                          this.replCarEntitlementCode
                        )
                          ? _c(
                              "span",
                              { staticClass: "extended-services-name-sub" },
                              [
                                _vm._v(
                                  "(" +
                                    _vm._s(
                                      _vm.$t(
                                        "detail.additionalServicesNotAgreed"
                                      )
                                    ) +
                                    ")"
                                ),
                              ]
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.serviceSlotDefinition.replacement_car_included == true &&
                  _vm.slotDefinition == true
                    ? _c("div", { staticClass: "extended-services" }, [
                        _c("img", {
                          staticClass: "extended-services-icon",
                          attrs: { src: "/img/icons/replacement-car.svg" },
                        }),
                        _vm._v(" "),
                        _vm.serviceSlotDefinition.replacement_car_cond == 1
                          ? _c(
                              "span",
                              { staticClass: "extended-services-name" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "detail.additionalServicesReplacementVehicle"
                                    )
                                  ) +
                                    " " +
                                    _vm._s(
                                      _vm.$t("detail.additionalServicesFree")
                                    ) +
                                    "**"
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.serviceSlotDefinition.replacement_car_cond == 0
                          ? _c(
                              "span",
                              { staticClass: "extended-services-name" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "detail.additionalServicesReplacementVehicle"
                                    )
                                  )
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.extendedServicesDeniedReplacementVehicleCodes.includes(
                          this.replCarEntitlementCode
                        )
                          ? _c(
                              "span",
                              { staticClass: "extended-services-name-sub" },
                              [
                                _vm._v(
                                  "(" +
                                    _vm._s(
                                      _vm.$t(
                                        "detail.additionalServicesNotAgreed"
                                      )
                                    ) +
                                    ")"
                                ),
                              ]
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _vm.slotDefinition == false ||
                (_vm.slotDefinition == true &&
                  _vm.serviceSlotDefinitionLoadStatus == 2)
                  ? _c("span", { staticClass: "service-info-text" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t("detail.additionalServicesChargeNote")
                          ) +
                          "\n            "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.serviceSlotDefinition.pickup_included == true &&
                _vm.slotDefinition == true &&
                _vm.serviceSlotDefinition.pickup_cond == 1
                  ? _c("span", { staticClass: "service-info-text" }, [
                      _vm._v(
                        "\n                * " +
                          _vm._s(
                            _vm.$t("detail.additionalServicesPickupNote")
                          ) +
                          "\n            "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.serviceSlotDefinition.replacement_car_included == true &&
                _vm.slotDefinition == true &&
                _vm.serviceSlotDefinition.replacement_car_cond == 1
                  ? _c("span", { staticClass: "service-info-text" }, [
                      _vm._v(
                        "\n                ** " +
                          _vm._s(
                            _vm.$t(
                              "detail.additionalServicesReplacementVehicleNote"
                            )
                          ) +
                          "\n            "
                      ),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.serviceLoadStatus == 2 &&
      (_vm.app_env == "local" || _vm.app_env == "development") &&
      (_vm.service.pickup_note ||
        _vm.service.replacement_car_note ||
        _vm.service.car_wash_note) &&
      _vm.workroom != 860
        ? _c("div", { staticClass: "grid-x" }, [
            _c("div", { staticClass: "large-12 medium-12 small-12 cell" }, [
              _c("hr"),
              _vm._v(" "),
              _c("span", { staticClass: "service-info-text" }, [
                _vm._v(_vm._s(_vm.service.pickup_note)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "service-info-text" }, [
                _vm._v(_vm._s(_vm.service.replacement_car_note)),
              ]),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }